import { render, staticRenderFns } from "./SavolJavobView.vue?vue&type=template&id=2c709d08&scoped=true&"
import script from "./SavolJavobView.vue?vue&type=script&lang=js&"
export * from "./SavolJavobView.vue?vue&type=script&lang=js&"
import style0 from "./SavolJavobView.vue?vue&type=style&index=0&id=2c709d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c709d08",
  null
  
)

export default component.exports